import { createMuiTheme } from '@material-ui/core/styles';
import { grey, orange, red } from '@material-ui/core/colors';

export default createMuiTheme({
    palette: {
        primary: {
            light: '#3a96cd',
            main: '#005084',
            dark: '#002e4c',
            contrastText: '#ffffff',
        },
        info: {
            light: orange[100],
            main: orange[600],
            dark: orange[800],
            contrastText: '#ffffff',
        },
        error: {
            light: red[100],
            main: red[600],
            dark: red[800],
            contrastText: '#ffffff',
        },
        common: {
            white: '#FFFFFF',
        },
        text: {
            secondary: grey[800],
        },
    },
});
